/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Empresa vista por el candidato [P_A_31]
 * @export
 * @interface CandidateCompany
 */
export interface CandidateCompany {
    /**
     * 
     * @type {number}
     * @memberof CandidateCompany
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CandidateCompany
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateCompany
     */
    sector?: string;
    /**
     * Texto libre corto
     * @type {string}
     * @memberof CandidateCompany
     */
    subtitle?: string;
    /**
     * url final para hacer get
     * @type {string}
     * @memberof CandidateCompany
     */
    logo?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateCompany
     */
    web?: string;
    /**
     * Texto libre corto
     * @type {string}
     * @memberof CandidateCompany
     */
    location?: string;
    /**
     * Texto libre largo
     * @type {string}
     * @memberof CandidateCompany
     */
    text?: string;
    /**
     * 
     * @type {number}
     * @memberof CandidateCompany
     */
    empleados?: number;
    /**
     * Url de youtube
     * @type {string}
     * @memberof CandidateCompany
     */
    video?: string;
}

export function CandidateCompanyFromJSON(json: any): CandidateCompany {
    return CandidateCompanyFromJSONTyped(json, false);
}

export function CandidateCompanyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CandidateCompany {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'sector': !exists(json, 'sector') ? undefined : json['sector'],
        'subtitle': !exists(json, 'subtitle') ? undefined : json['subtitle'],
        'logo': !exists(json, 'logo') ? undefined : json['logo'],
        'web': !exists(json, 'web') ? undefined : json['web'],
        'location': !exists(json, 'location') ? undefined : json['location'],
        'text': !exists(json, 'text') ? undefined : json['text'],
        'empleados': !exists(json, 'empleados') ? undefined : json['empleados'],
        'video': !exists(json, 'video') ? undefined : json['video'],
    };
}

export function CandidateCompanyToJSON(value?: CandidateCompany | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'sector': value.sector,
        'subtitle': value.subtitle,
        'logo': value.logo,
        'web': value.web,
        'location': value.location,
        'text': value.text,
        'empleados': value.empleados,
        'video': value.video,
    };
}


